module.exports = __webpack_public_path__ + "static/media/icon-lp-medication.48a9f676.svg";